<template>
  <div class="summary-container">
    <span class="dot text-center">
      <i class="user-log-icon fas fa-id-card-alt"></i>
    </span>
    <span class="field-label d-inline-block user-log-label">Ultimo Acceso:</span>
    <span>{{lastAccessDateFormated || 'No Disponible'}}</span>

    <div class="d-inline-block user-log-divider"></div>

    <span class="field-label d-inline-block user-log-label">Aprobación:</span>
    <i
      class="user-log-icon fas"
      :class="[user.isApproved ? 'fa-check color-green' :'fa-clock color-yellow']"
      style="margin-right:8px;"
    ></i>
    <span>{{user.isApproved ? 'Aprobada' : 'Pendiente'}}</span>

    <div class="d-inline-block user-log-divider"></div>

    <span class="field-label d-inline-block user-log-label">Bloqueo:</span>
    <i
      class="user-log-icon fas"
      :class="[user.isLockedOut ? 'fa-lock color-red' :'fa-lock-open color-green']"
      style="margin-right:8px;"
    ></i>

    <span>{{user.isLockedOut ? 'Bloqueado' : 'Desbloqueado'}}</span>

  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'UserSummaryBar',
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  computed: {
    lastAccessDateFormated() {
      return this.user.lastAccessDate
        ? moment(this.user.lastAccessDate)
            .locale('es-PR')
            .format('D/MMM/YYYY - H:mm a')
        : ''
    },
  },
}
</script>

<style scoped>
.summary-container {
  border-radius: 21px;
  background-color: #f7f7f7;
  padding: 4px;
}

.user-log-icon {
  font-size: 1rem;
  color: #fff;
}

.color-green {
  color: #a3e4b1;
}

.color-yellow {
  color: #ffcd71;
}

.user-log-label {
  margin: 0 10px 0 10px;
}

.user-log-divider {
  vertical-align: middle;
  height: 29px;
  border-right: 1px solid #e2e2e2;
  margin: 0 6px 0 16px;
}

.dot {
  background-color: #2db782;
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}
</style>